import { OrderContractWorkspace } from './order-contract-workspace.tsx'

export function RentalContractPage({
  rentalOrderId,
  documentId,
  canManage,
  canSubmit
}: {
  rentalOrderId: number
  documentId?: number
  canManage: boolean
  canSubmit: boolean
}) {
  return (
    <OrderContractWorkspace
      ids={[rentalOrderId]}
      documentId={documentId}
      canEdit={canManage || canSubmit}
      canManage={canManage}
    />
  )
}
